module.exports = __webpack_public_path__ + "img/warning.17068f06.svg";